<script setup lang="ts">

import InterviewSurveyDialog from "@/interview/components/instance-modal/InterviewSurveyDialog.vue";
import {SurveyAnswerInstance} from "@/core/interfaces/survey/Survey";
import BaseButton from "@/core/components/base/BaseButton.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import {Skeleton} from "@/core/components/ui/skeleton";

const emits = defineEmits<{
    (e: 'save', answers: Record<number, (string | number | boolean | undefined)[]>): void;
}>();

defineProps<{
    surveyInstance?: SurveyAnswerInstance
}>();
</script>

<template>
  <BaseCard>
    <BaseCardBody class="justify-center flex">
      <Skeleton v-if="!surveyInstance" class="w-56 h-8 mx-auto" />
      <InterviewSurveyDialog
        v-else
        :instance="surveyInstance"
        :submitting="false"
        @save="(answers) => emits('save', answers)"
      >
        <BaseButton primary class="px-12">
          Voir les réponses à l’auto-évaluation
        </BaseButton>
      </InterviewSurveyDialog>
    </BaseCardBody>
  </BaseCard>
</template>

<style scoped>

</style>
